import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'defaultNumber',
})
export class DefaultNumberPipe implements PipeTransform {
  transform(num: number | null, defaultValue: string | number = 0) {
    return num ? num : defaultValue;
  }
}
